<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M13 3H17V5H13V3ZM3 8H7V10H3V8ZM3 16H7V18H3V16ZM2 12H5.99V14H2V12ZM21.707 6.707L20.293 5.293L18.586 7C17.5041 6.34616 16.2641 6.00037 15 6C11.141 6 8 9.141 8 13C8 16.859 11.141 20 15 20C18.859 20 22 16.859 22 13C21.999 11.2461 21.3366 9.55701 20.145 8.27L21.707 6.707ZM16 14H14V8.958H16V14Z"
            fill="currentColor"
        />
    </svg>
</template>
